var exports = {
  "K2": "PricingGrid.module__gridWrapper___ZUN6Wl",
  "Vg": "PricingGrid.module__grid___ZUN6Wl",
  "mS": "PricingGrid.module__gridTwoColumns___ZUN6Wl" + " " + "PricingGrid.module__grid___ZUN6Wl",
};

module.exports = exports;
